export default __webpack_public_path__ + "static/media/header_paper.d5e09f37.jpg";